module.exports = __webpack_public_path__ + "fonts/Arimo-700-latin32.35e619f.woff2";